import { create } from 'zustand'
import { persist } from "zustand/middleware"
import { getScopedItem, removeScopedItem, setScopedItem } from '../components/common/Helper';

let ZustStore = (set) => ({
    dopen: true,
    chatbotOpen: false,
    updateOpen: (dopen) => set((state) => ({ dopen: dopen })),
    setChatbotOpen: (open) => set({ chatbotOpen: open }),
    toggleChatbot: () => set((state) => ({ chatbotOpen: !state.chatbotOpen })),
})

ZustStore = persist(ZustStore, { name: 'my_zust_store', partialize: (state) => ({ chatbotOpen: state.chatbotOpen }) });

export const useZustStore = create(ZustStore);

export const useSelectedInstancesStore = create((set) => ({
    selectedRunningInstances: [],
    selectedStoppedInstances: [],
    // selectedDropdownOption: '',
    addSelectedRunningInstance: (instanceId) => set((state) => {
        const updatedRunningInstances = state.selectedRunningInstances.includes(instanceId)
            ? state.selectedRunningInstances.filter(id => id !== instanceId)
            : [...state.selectedRunningInstances, instanceId];
        const updatedStoppedInstances = [];
        return { selectedRunningInstances: updatedRunningInstances, selectedStoppedInstances: updatedStoppedInstances };
    }),
    addSelectedStoppedInstance: (instanceId) => set((state) => {
        const updatedStoppedInstances = state.selectedStoppedInstances.includes(instanceId)
            ? state.selectedStoppedInstances.filter(id => id !== instanceId)
            : [...state.selectedStoppedInstances, instanceId];
        const updatedRunningInstances = [];
        return { selectedRunningInstances: updatedRunningInstances, selectedStoppedInstances: updatedStoppedInstances };
    }),
}));


export const useSelectedRDSStore = create((set) => ({
    selectedRunningDBS: [],
    selectedStoppedDBS: [],
    addSelectedRunningDB: (dbIdentifier) => set((state) => {
        const updatedRunningDBS = state.selectedRunningDBS.includes(dbIdentifier)
            ? state.selectedRunningDBS.filter(id => id !== dbIdentifier)
            : [...state.selectedRunningDBS, dbIdentifier];
        const updatedStoppedDBS = [];
        return { selectedRunningDBS: updatedRunningDBS, selectedStoppedDBS: updatedStoppedDBS };
    }),
    addSelectedStoppedDB: (dbIdentifier) => set((state) => {
        const updatedStoppedDBS = state.selectedStoppedDBS.includes(dbIdentifier)
            ? state.selectedStoppedDBS.filter(id => id !== dbIdentifier)
            : [...state.selectedStoppedDBS, dbIdentifier];
        const updatedRunningDBS = [];
        return { selectedRunningDBS: updatedRunningDBS, selectedStoppedDBS: updatedStoppedDBS };
    }),
}));

useSelectedRDSStore.subscribe((state) => {
    if (state.selectedRunningDBS.length > 0) {
        useSelectedInstancesStore.setState({ selectedRunningInstances: [] });
    }
});

export const useDateStore = create((set) => ({
    formattedStop: null,
    formattedStart: null,
    // Function to set formatted dates
    setFormattedDates: (formattedStop, formattedStart) => {
        set({ formattedStop, formattedStart });
    },
}));

export const Ec2InstanceDetails = create((set) => ({
    instanceDetails: JSON.parse(getScopedItem('instanceDetails')) || null,
    setInstanceDetails: (details) => {
        removeScopedItem('instanceDetails');
        setScopedItem('instanceDetails', JSON.stringify(details));
        set({ instanceDetails: details });
    },
    clearInstanceDetails: () => {
        removeScopedItem('instanceDetails');
        set({ instanceDetails: null });
    },
}));


export const RDSInstanceDetails = create((set) => ({
    RDSinstanceDetails: JSON.parse(getScopedItem('RDSinstanceDetails')) || null,
    setInstanceDetails: (details) => {
        removeScopedItem('RDSinstanceDetails');
        setScopedItem('RDSinstanceDetails', JSON.stringify(details));
        set({ RDSinstanceDetails: details });
    },
    clearInstanceDetails: () => {
        removeScopedItem('RDSinstanceDetails');
        set({ RDSinstanceDetails: null });
    },
}));

